const services = [
  {
    number: "01",
    title: "Build a web application",
    description:
      "Turn a product idea or manual process into a complete web app, with an interface, application logic, data, and deployment.",
    tags: ["React", "Next.js", "PostgreSQL"],
  },
  {
    number: "02",
    title: "Move a product forward",
    description:
      "Add a feature, connect an API, or take on a defined piece of an existing product alongside your team.",
    tags: ["Features", "APIs", "Integrations"],
  },
  {
    number: "03",
    title: "Improve a real workflow",
    description:
      "Create focused tools for the repeatable work behind a business, from tracking and reporting to client-facing workflows.",
    tags: ["Workflow tools", "Reporting", "Operations"],
  },
];

export default function Services() {
  return (
    <section className="section section--soft" id="services">
      <div className="section-wrap">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Ways I can help</p>
            <h2>Engineering support for the work ahead.</h2>
          </div>
          <p className="section-heading__aside">
            Bring a project, a backlog, or a workflow that needs better software.
          </p>
        </div>
        <div className="service-grid">
          {services.map((service) => (
            <article className="service-card" key={service.number}>
              <span className="service-card__number">{service.number}</span>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <div className="tag-list">
                {service.tags.map((tag) => <span key={tag}>{tag}</span>)}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
